import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import type { Dispatch, GetState } from '../../../../../model/State';
import { fetchBTFProductAvailableForEvaluation } from '../product';
import { fetchVendorTerms } from '../marketplace';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
  }
  const { addonKey } = getState().location.payload;

  dispatch(fetchBTFProductAvailableForEvaluation(addonKey));
  dispatch(fetchVendorTerms(addonKey));
};
